import {ENV_TYPES} from './EnvironmentTypes';
import {getHostnameFromUrl} from '@components/utils/UrlUtils';

export const STATIC_MAIN_DOMAIN = 'stillwaterinsurance.com';

export const ENV_BASE_URL: Record<ENV_TYPES, string> = {
  [ENV_TYPES.DEV]: `https://qua.${STATIC_MAIN_DOMAIN}/`,
  [ENV_TYPES.LOCAL]: `https://qua.${STATIC_MAIN_DOMAIN}/`,
  // [ENV_TYPES.LOCAL]: `http://localhost:8080/`,
  [ENV_TYPES.PROD]: `https://${STATIC_MAIN_DOMAIN}/`,
  [ENV_TYPES.STAGING]: `https://staging.${STATIC_MAIN_DOMAIN}/`,
  [ENV_TYPES.INT]: `https://int.${STATIC_MAIN_DOMAIN}/`,
  [ENV_TYPES.TRAINING]: `https://training.${STATIC_MAIN_DOMAIN}/`
};

// Only to be used for comparision //
export const ENV_BASE_URL_HOSTNAME: Record<ENV_TYPES, string> = {
  [ENV_TYPES.DEV]: getHostnameFromUrl(ENV_BASE_URL[ENV_TYPES.DEV]),
  [ENV_TYPES.LOCAL]: getHostnameFromUrl(ENV_BASE_URL[ENV_TYPES.LOCAL]),
  [ENV_TYPES.PROD]: getHostnameFromUrl(ENV_BASE_URL[ENV_TYPES.PROD]),
  [ENV_TYPES.STAGING]: getHostnameFromUrl(ENV_BASE_URL[ENV_TYPES.STAGING]),
  [ENV_TYPES.INT]: getHostnameFromUrl(ENV_BASE_URL[ENV_TYPES.INT]),
  [ENV_TYPES.TRAINING]: getHostnameFromUrl(ENV_BASE_URL[ENV_TYPES.TRAINING])
};
